"use client"

import IconFilter from "@/app/(site)/_components/Atoms/Icons/IconFilter"
import FilterChips from "@/app/(site)/_components/Organisms/ProductGrids/Filter/FilterChips"
import { useHideGladlyIcon } from "@/app/(site)/_utils/_hooks/useHideGladlyIcon"
import { useScrollDirection } from "@/app/(site)/_utils/_hooks/useScrollDirection"
import {
    useProductGridContext,
    useStaticGridContext
} from "@/app/(site)/contexts/product-grid/ProductGridContext"
import { clsx } from "@/src/utils/clsx"

export default function MobileStickyFilterBar() {
    const { filterState, openMobileFilter } = useProductGridContext()
    const { categoryTranslations } = useStaticGridContext()
    useHideGladlyIcon(false, { hideOnMobile: true })

    const filterCount = filterState.filters.reduce((acc, f) => acc + f.data.length, 0)
    const { scrollDirection } = useScrollDirection()
    const showChips = filterCount > 0 && scrollDirection === "up"

    const handleOpen = () => {
        openMobileFilter()
    }
    return (
        <div className="fixed bottom-0 left-0 z-[var(--z-header)] w-full lg:hidden">
            <div
                className={clsx(
                    "absolute bottom-full left-0 flex w-full gap-12 overflow-x-auto border-t border-col-border-neutral bg-white px-12 py-10 transition-all duration-300 ease-in-out thin-scrollbar",
                    showChips ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"
                )}
            >
                <FilterChips />
            </div>
            <button
                onClick={handleOpen}
                className="relative z-10 flex h-48 w-full items-center justify-between border-b border-t border-col-border-neutral bg-col-bg-calm px-12 pb-[14px] pt-14"
                aria-label={categoryTranslations.showFilterSorting}
            >
                <div className="flex items-center gap-8">
                    <IconFilter />
                    <span className="pt-2 Trim_Mono_POC_Text_14_130_-5_500_uppercase">
                        {categoryTranslations.showFilterSorting}
                    </span>
                </div>
                {filterCount > 0 && (
                    <span className="Trim_Mono_POC_Text_14_130_0_400_uppercase">
                        ({filterCount})
                    </span>
                )}
            </button>
        </div>
    )
}
